<template>
    <div class="doc-section">
        <h1>Editar usuario</h1>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <p>
            En la tabla de usuarios, hacer clic sobre el botón de editar representado con el icono mostrará la vista de
            editar usuario.
        </p>

        <ul class="ul-contenedor step-list">
            <li>a) Nombre del usuario, identificador del usuario, valor con el que inicia sesión el usuario.</li>
            <li>b) Rol de usuario, rol asignado a usuario.</li>
            <li>c) Grupo perteneciente.</li>
        </ul>
        <div class="info-card">
            <p>
                <strong>Nota:</strong> Al guardar los cambios del usuario exitosamente se mostrará una notificación en
                la parte superior derecha de sistema.
            </p>
        </div>

        <h3>Referencia Visual</h3>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesFiltradas" />
        </div>

        <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesFiltradas" />
        </div>
    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'EditarUsuario',
    components: { CarruselAciqui, plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        // 🎯 Unificamos los datos en una sola estructura limpia
        imagenesBase: [
            {
                nombre: "Editar usuario",
                urlWeb: "img/usuarios/editarUsuario.png",
                urlMovil: "img/usuarios/moviles/editarUsuario.png",
                descripcion: "Formulario para editar un usuario"
            },
            {
                nombre: "Exito al editar usuario",
                urlWeb: "img/usuarios/exitoEditarUsuario.png",
                urlMovil: "img/usuarios/exitoEditarUsuario.png",
                descripcion: "Mensaje de exito al editar un usuario"
            },
        ]
    }),
    computed: {
        // 🎯 Lógica dinámica que limpia las líneas repetidas ante SonarQube
        imagenesFiltradas() {
            return this.imagenesBase.map(img => ({
                nombre: img.nombre,
                descripcion: img.descripcion,
                url: this.plataforma === 'web' ? img.urlWeb : img.urlMovil
            }));
        }
    },
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>